import { httpReport } from './report'
import { needReport } from './tools'
import { whiteList } from './conf'
import { EventTypeMap } from './report-event'
import store from '@/public/store'
export const ReportDomTag = '__reportIO__'


const reportCache = {}

let reportIOInstance = null

export function destoryReportIOInstance () {
  if (reportIOInstance) {
    reportIOInstance.disconnect()
    reportIOInstance = null
  }
}

// 模块访问
export function moudleMonitor (params) {
  report(params, EventTypeMap.module)
}

// 检查曝光 元素可见时上报
export function exposureMonitor (params) {
  const { dom } = params
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1 // 阈值 (threshold) 大于 0.1就执行
  }
  reportIOInstance = new IntersectionObserver((entries) => {
    entries.forEach(item => {
      if (item.isIntersecting) {
        reportIOInstance && reportIOInstance.unobserve(item.target)
        dom[ReportDomTag] = null
        if (params.functionalComReportName) {
          report({...params, name: params.functionalComReportName, componentName: params.functionalComReportName}, EventTypeMap.exposure)
        }
        report(params, EventTypeMap.exposure)
      }
    })
  }, options)
  if (dom) {
    dom[ReportDomTag] = reportIOInstance
    dom instanceof HTMLElement && reportIOInstance.observe(dom)
  }
}

function report(params, type) {
  const { tag, menuId, functionalComReportName = '' } = params
  const tagsView = store.state.tagsView
  const menuOpenId = tagsView && tagsView.logs && tagsView.logs[menuId]
  const cacheKey = type + tag + menuId + menuOpenId + functionalComReportName
  if (!reportCache[cacheKey]) {
    params.eventType = type
    httpReport(params)
    reportCache[cacheKey] = true
  }
}

function reportIter (params) {
  const { tag, reportName } = params
  const { name } = whiteList.find(ele => ele.tag === tag) || {}
  if (needReport(tag) || reportName) {
    params.name = name
    params.componentName = tag
    if (reportName) {
      params.name = reportName
      params.componentName = reportName
    }
    moudleMonitor(params)
    exposureMonitor(params)
  }
}

export function reportCompoent (params) {
  const { dom } = params
  const functionalComReportName = dom && typeof dom.getAttribute === 'function' && dom.getAttribute('data-report-name')
  if (functionalComReportName) {
    reportIter({...params, reportName: functionalComReportName, functionalComReportName})
  }
  reportIter(params)
}



// WEBPACK FOOTER //
// ./src/public/mixins/component-report/monitor.js